import {createStore} from 'redux';
import reducers from '../reducers';

const configureStore = () => {
    return createStore(reducers);
};

const store = configureStore();

export default store;
